import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { AddCircleOutlined, DoNotDisturbOnOutlined } from "@mui-symbols-material/w300"

interface UserDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  isActive: boolean
  onDeactivate: () => void
  onActivate: () => void
  disabled?: boolean
}

const UserDropdownMenu: React.FC<UserDropdownMenuProps> = ({
  anchorEl,
  onClose,
  isActive,
  onDeactivate,
  onActivate,
  disabled = false,
}) => {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      {isActive ? (
        <MenuItem onClick={onDeactivate} disabled={disabled}>
          <ListItemIcon>
            <DoNotDisturbOnOutlined />
          </ListItemIcon>
          <ListItemText primary='Deactivate' />
        </MenuItem>
      ) : (
        <MenuItem onClick={onActivate} disabled={disabled}>
          <ListItemIcon>
            <AddCircleOutlined />
          </ListItemIcon>
          <ListItemText primary='Activate' />
        </MenuItem>
      )}
    </Menu>
  )
}

export default UserDropdownMenu
